import React from 'react'

const TrackingInvoiceNumber = ({ showOrHide, clientCode, trackingNumber, shipmentObjUpdateEvent, inputFieldsReadOnly, language }) => {

    let trackingNumberName = "Invoice / Pro Number:"
    if (clientCode) {
        if (clientCode.includes('kwiktrip') || clientCode.includes('halliburton') || clientCode.includes('fishinco')) {
            trackingNumberName = "Pro Number:"
        }
        if (clientCode === 'Schuff' || clientCode === 'graywolf') {
            trackingNumberName = "Invoice Number:"
        }
    }

    if (language && language.code === "es") {
        trackingNumberName = "Número de factura / Pro:"
        if (clientCode) {
            if (clientCode.includes('kwiktrip') || clientCode.includes('halliburton') || clientCode.includes('fishinco')) {
                trackingNumberName = "Número Pro:"
            }
            if (clientCode === 'Schuff' || clientCode === 'graywolf') {
                trackingNumberName = "Número de factura:"
            }
        }
    }

    if (showOrHide === "show" || showOrHide === "hilight") {
        return (

            <div className={showOrHide}>
                {trackingNumberName}
                <br />
                <input
                    className="form-control form-control-sm"
                    type="text"
                    name="charges.trackingNumber"
                    value={
                        trackingNumber === null
                            ? ""
                            : trackingNumber
                    }
                    onChange={(event) => shipmentObjUpdateEvent(event)}
                    disabled={inputFieldsReadOnly}
                />
            </div>

        )
    } else { return null }
}

export default TrackingInvoiceNumber
